import { render, staticRenderFns } from "./paySuccess.vue?vue&type=template&id=4c4f65ff&scoped=true&"
import script from "./paySuccess.vue?vue&type=script&lang=ts&"
export * from "./paySuccess.vue?vue&type=script&lang=ts&"
import style0 from "./paySuccess.vue?vue&type=style&index=0&id=4c4f65ff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4f65ff",
  null
  
)

export default component.exports